<template>
  <transition name="fade">
    <div class="ui-play-icon" v-show="showPlayIcon" @click.stop="handleClick">
      <div class="icon icon-play" v-show="playStatus === 'play'"></div>
      <div class="icon icon-pause" v-show="playStatus === 'pause'"></div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'uiPlayIcon',
  props: {
    // 播放状态， play - 播放，pause - 暂停
    playStatus: {
      type: String,
      default: 'play'
    },
    showPlayIcon: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleClick (e) {
      this.$emit('click', e)
    }
  }
}
</script>
<style lang="scss" scoped>
.ui-play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 20;
  transform: translate3d(-50%, -50%, 0);
  height: 0.9rem;
  width: 0.9rem;
  .icon {
    height: 100%;
    width: 100%;
    &.icon-play {
      background: url("./images/previewpage_icon_play@2x.png") no-repeat center;
      background-size: 96%;
    }
    &.icon-pause {
      background: url("./images/previewpage_icon_pause@2x.png") no-repeat center;
      background-size: 96%;
    }
  }
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-to,
.fade-leave {
  opacity: 1;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s;
}
</style>
